<template>
  <div class="intro-y box" v-if="team_session != 1">
    <div class="flex flex-col px-5 pt-5 pb-2">
        <div class="mb-2">Horas usadas en la semana del <b>{{start_date}}</b> al <b>{{end_date}}</b></div>
        <div class="w-full h-4 bg-gray-400 rounded">
          <div class="h-full rounded text-center text-xs text-white bg-theme-6" v-if="percentage > 100"
            :style="{ width: '100%' }">{{percentage}}%</div>
          <div class="h-full rounded text-center text-xs text-white bg-theme-1" v-else
            :style="{ width: percentage > 0 ? percentage+'%' : '0px' }">{{percentage}}%</div>
        </div>
    </div>
    <div class="flex justify-between mx-5 pb-3">
        <div>{{hours_used}} Horas Usadas</div>
        <div>{{hours_account}} Horas</div>
    </div>
  </div>
  <div class="intro-y box mt-6" v-else>
    <div class="flex flex-col px-5 pb-2">
        <div v-for="project in projects">
          <div class="flex flex-col px-5 pt-5 pb-2">
              <div class="mb-2"><b :class="[
                project.hours > 1
                  ? 'text-theme-1'
                  : '',
              ]">{{project.name}}</b></div>
              <div class="w-full h-4 bg-gray-400 rounded">
                <div class="h-full rounded text-center text-xs text-white bg-theme-6" v-if="project.percentage > 100"
                  :style="{ width: '100%' }">{{project.percentage}}%</div>
                <div class="h-full rounded text-center text-xs text-white bg-theme-1" v-else
                  :style="{ width: project.percentage > 0 ? project.percentage+'%' : '0px' }">{{project.percentage}}%</div>
              </div>
          </div>
          <div class="flex justify-between mx-5 pb-3">
              <div>{{project.hours_used}} Horas Usadas</div>
              <div>{{project.hours}} Horas</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: [
      'team_session',
      'account_session',
    ],
    data() {
      return {
        percentage: 0,
        start_date: null,
        end_date: null,
        hours_account: 0,
        hours_used: 0,
        projects: []
      }
    },
    async beforeMount () {
      await this.getInfo()
    },
    methods: {
      ...mapActions([
        'get'
      ]),
      async getInfo() {
        this.loading = true
        try {
          const { percentage , start_date, end_date, hours_account, hours_used, projects_hours } = await this.get(`/hours-account/${this.account_session}/${this.team_session}`)
          if(this.team_session != "1") {
            this.percentage = percentage
            this.start_date = start_date
            this.end_date = end_date
            this.hours_account = hours_account
            this.hours_used = hours_used
          } else {
            this.projects = projects_hours
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    }
  }
</script>




// WEBPACK FOOTER //
// HoursTasksComponent.vue?14c59396